var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM6.49219 7.82516C5.29252 7.82516 4.31734 8.80033 4.31734 10C4.31734 11.1997 5.29252 12.1748 6.49219 12.1748H9.29844V13.5078H6.49219C4.55587 13.5078 2.98438 11.9363 2.98438 10C2.98438 8.06369 4.55587 6.49219 6.49219 6.49219H9.29844V7.82516H6.49219ZM10.7016 6.49219H13.5078C15.4441 6.49219 17.0156 8.06369 17.0156 10C17.0156 11.9363 15.4441 13.5078 13.5078 13.5078H10.7016V12.1748H13.5078C14.7075 12.1748 15.6827 11.1997 15.6827 10C15.6827 8.80033 14.7075 7.82516 13.5078 7.82516H10.7016V6.49219ZM12.8063 10.7016H7.19375V9.29844H12.8063V10.7016Z",
    fill: "#002106"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.12ead9869cab1fb3ecd466dcb299a75c.svg";
export { ForwardRef as ReactComponent };